import { gql } from '@apollo/client';
import { MESSAGE_FIELDS_FRAGMENT } from './messageFieldsFragment.ggl';

const FETCH_LAST_CUSTOMER_MESSAGE_QUERY = gql`
  query fetchLastCustomerMessageQuery($filter: MessageFilter, $sorting: [MessageSort!]) {
    messageFindFirst(filter: $filter, sorting: $sorting) {
      messageBody
    }
  }
`;

const FETCH_MESSAGES_IN_CONVERSATION_FOR_ADMIN_QUERY = (flowDebugStateEnabled = false) => gql`
  ${MESSAGE_FIELDS_FRAGMENT}
  query fetchMessagesInConversationForAdminQuery(
    $filter: MessageFilter
    $sorting: [MessageSort!]
    $paging: CursorPaging
  ) {
    messagesFind(filter: $filter, sorting: $sorting, paging: $paging) {
      nodes {
        ...MessageFields
        simplrExpertId
        simplrExpertPtr {
          objectId: id
          isActive
          isSystemExpert
          firstName
          lastName
          email
        }
        ${flowDebugStateEnabled ? 'flowDebugState' : ''}
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

const FETCH_MESSAGES_IN_CONVERSATION_QUERY = gql`
  ${MESSAGE_FIELDS_FRAGMENT}
  query fetchMessagesInConversation($filter: MessageFilter, $sorting: [MessageSort!], $paging: CursorPaging) {
    messagesFind(filter: $filter, sorting: $sorting, paging: $paging) {
      nodes {
        ...MessageFields
        simplrExpertId
        simplrExpertPtr {
          objectId: id
          isActive
          isSystemExpert
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export {
  FETCH_LAST_CUSTOMER_MESSAGE_QUERY,
  FETCH_MESSAGES_IN_CONVERSATION_QUERY,
  FETCH_MESSAGES_IN_CONVERSATION_FOR_ADMIN_QUERY,
};
